module.exports = __webpack_public_path__ + "static/media/huoyanshan_mobile.73846524.webp";